module.exports = __webpack_public_path__ + "31230983e4ab4ddbb4980a2f2dac9ab6.pdf";